import React from 'react';
import { FormattedMessage } from 'react-intl';
import NumberFormat from 'react-number-format';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const NumberFormatCustom = React.forwardRef((props, ref) => {
  const { onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value ? parseFloat(values.value) : values.value,
          },
        });
      }}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={2}
      fixedDecimalScale
      suffix=" m²"
      isNumericString
    />
  );
});

NumberFormatCustom.propTypes = {
  onChange: PropTypes.func.isRequired,
};

function RequestFormWidgetAreaDisable({ id, label, onChange, rawErrors, required, value }) {
  const error = !!(rawErrors && rawErrors.length > 0);

  return (
    <div className="w-full">
      <label 
        className="inline-block text-[12px] font-bold text-[#212529] font-['Open_Sans'] mt-[0.3vh] mb-1 tracking-tight" 
        htmlFor={id}
      >
        <FormattedMessage id={label} />
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>

      <NumberFormatCustom
        disabled
        id={id}
        data-cy={String(label).toLowerCase()}
        value={value || ''}
        onChange={event => onChange(event.target.value)}
        style={{ fontWeight: 'normal', color: 'rgba(0, 0, 0, 0.38)' }}
        className={classNames(
          "w-full bg-[#efefef] border-[1px] border-solid rounded-[4px] !h-[37px] !px-[12px] py-[6px] text-[14px] !font-normal font-['Open_Sans'] cursor-not-allowed text-[rgba(0,0,0,0.38)] transition-all",
          {
            "border-[#dc3545]": error,
            "border-[#ced4da]": !error
          }
        )}
      />
      {error && (
        <p className="order-form-field-error">
          {rawErrors[0]}
        </p>
      )}
    </div>
  );
}

RequestFormWidgetAreaDisable.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  rawErrors: PropTypes.array,
  required: PropTypes.bool.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

RequestFormWidgetAreaDisable.defaultProps = {
  rawErrors: [],
  value: undefined,
};

export default RequestFormWidgetAreaDisable;
